import './aboutus.css';
import { Link } from 'react-router-dom'
import groupimg from "../imgs/grouppic.jpeg"
import divapic from "../imgs/divapic.jpeg"
import tejaspic from "../imgs/tejaspic.jpeg"
import mypic from "../imgs/mypicture.jpeg"
import surabhipic from "../imgs/surabhipic.jpg"
import anyapic from "../imgs/anyapic.jpg"
import lahotipic from "../imgs/lahotipic.jpg"
import vivpic from "../imgs/vivpic.jpg"
import finojpic from "../imgs/finojpic.jpeg"
import kharyapic from "../imgs/kharyapic.jpeg"
import khyatipic from "../imgs/khyatipic.jpeg"
import babanpic from "../imgs/babanpic.jpeg"
import sidpic from "../imgs/sidpic.jpg"
import rishikapic from "../imgs/rishikapic.jpg"
import subashpic from "../imgs/subashpic.jpeg"
export default function Aboutus() {
    return (
        <>
        {/* hi */}
            <div className='bigger'>
                <div className='big'>
                    <div className='head1'>About Us</div>
                    <div className='headz'>
                        <div className='about-card-left'>
                            <div ><img className='about-card-image' src={groupimg} /></div>
                            <div className='about-card-title'>TBH</div>
                            <div className='about-card-subtitle'>
                                THE BITS HERALD
                            </div>
                        </div>
                        <div className='about-card-right'>
                            The BITS Herald is a club which covers all campus events, such as student body and academic elections, administrative policy changes, initiatives, and events. Our primary responsibility is to keep the general body informed about events, initiatives, announcements, and key developments through reliable journalism.
                            Our verticals include writing, interviewing, designing and web development.
                            We write articles on topics relevant to the student body, which is also updated on our instagram handle: thebitsherald. We conduct interviews with election candidates of the council of student affairs (CSA), and other academic election candidates to present their ideas, goals, and perspectives in an unbiased and accessible manner.
                            The BITS Herald will serve as a central archive to all the club’s works, reflecting its consistency and commitment to the general body as a journalism club.
                            Through consistent reporting, digital outreach, and student involvement, The BITS Herald plays an important role in informing the campus and strengthening student communication.

                        </div>
                    </div>
                    <div className='head1 sp'>Meet The Team</div>
                    <div className='team-subhead'>COORDINATORS- 2025-26</div>
                    <div className='team-section'>

                        <div className='team-grid'>
                            <div className='team-card'>
                                <img className='team-photo' src={tejaspic}></img>
                                <div className='team-role'>Chief Coordinator</div>
                                <div className='team-name'>Tejas</div>
                            </div>
                            <div className='team-card'>
                                <img className='team-photo' src={divapic}></img>
                                <div className='team-role'>Sub-Coordinator</div>
                                <div className='team-name'>Diva</div>
                            </div>

                        </div>

                    </div>


                    <div className='team-subhead'>CORE 2025-26</div>
                    <div className='team-grid '>
                        <div className='team-card'>
                            <img className='team-photo' src={mypic}></img>
                            <div className='team-role'>Webdev</div>
                            <div className='team-name'>Ishaan Gulati</div>
                        </div>
                        <div className='team-card'>
                            <img className='team-photo' src={surabhipic}></img>
                            <div className='team-role'>Designer</div>
                            <div className='team-name'>Surabhi Patil</div>
                        </div>
                        <div className='team-card'>
                            <img className='team-photo' src={anyapic}></img>
                            <div className='team-role'>Core</div>
                            <div className='team-name'>Anya Seth Syed</div>
                        </div>
                        <div className='team-card'>
                            <img className='team-photo' src={lahotipic}></img>

                            <div className='team-role'>Events</div>
                            <div className='team-name'>Manav Lahoti</div>
                        </div>
                    </div>




                    <div className='team-grid '>
                        <div className='team-card'>
                            <img className='team-photo' src={vivpic}></img>
                            <div className='team-role'>Writer</div>
                            <div className='team-name'>Samarth Vivek</div>
                        </div>
                        <div className='team-card'>
                            <img className='team-photo' src={finojpic}></img>
                            <div className='team-role'>Events</div>
                            <div className='team-name'>Aamil Finoj</div>
                        </div>
                        <div className='team-card'>
                            <img className='team-photo' src={rishikapic}></img>
                            <div className='team-role'>Designer</div>
                            <div className='team-name'>Rishika Gupta</div>
                        </div>
                        <div className='team-card'>
                            <img className='team-photo' src={babanpic}></img>
                            <div className='team-role'>Core</div>
                            <div className='team-name'>Rohan Mathew</div>
                        </div>
                    </div>
                    <div className='team-grid '>
                        <div className='team-card'>
                            <img className='team-photo' src={kharyapic}></img>
                            <div className='team-role'>Writer</div>
                            <div className='team-name'>Aditi Kharya</div>
                        </div>
                        <div className='team-card'>
                            <img className='team-photo' src={subashpic}></img>
                            <div className='team-role'>Core</div>
                            <div className='team-name'>Siddharthan Subash</div>
                        </div>
                        <div className='team-card'>
                            <img className='team-photo' src={khyatipic}></img>
                            <div className='team-role'>Writer</div>
                            <div className='team-name'>Khyati Saklani</div>
                        </div>
                        <div className='team-card'>
                            <img className='team-photo' src={sidpic}></img>
                            <div className='team-role'>Core</div>
                            <div className='team-name'>Siddharth Reddy</div>
                        </div>

                    </div>
                </div>
            </div>
        </>)
}